import React from "react";

import {areaFormat, priceFormat} from "@pg-mono/string-utils";

export const getPropertyBoxMultileadText = (areaDifference: number, priceDifference: number) => {
    const areaValue = areaFormat(Math.abs(areaDifference));
    const priceValue = priceFormat(Math.abs(priceDifference));

    const hasPriceDifference = Math.round(priceDifference) !== 0;
    const hasAreaDifference = Math.round(areaDifference) !== 0;

    if (!hasPriceDifference && !hasAreaDifference) return null;

    return (
        <>
            {hasPriceDifference && (
                <>
                    {priceDifference > 0 ? "Tańsze o " : "Droższe o "}
                    <strong>{priceValue}</strong>
                    {hasAreaDifference ? " " : ""}
                </>
            )}
            {hasAreaDifference && (
                <>
                    {areaDifference > 0 ? "mniejsze " : "większe "}
                    <strong>{areaValue}</strong>
                </>
            )}
        </>
    );
};
import React from "react";

import {areaFormat, priceFormat} from "@pg-mono/string-utils";

export const getPropertyBoxMultileadText = (areaDifference: number, priceDifference: number) => {
    const areaValue = areaFormat(Math.abs(areaDifference));
    const priceValue = priceFormat(Math.abs(priceDifference));

    const hasPriceDifference = Math.round(priceDifference) !== 0;
    const hasAreaDifference = Math.round(areaDifference) !== 0;

    if (!hasPriceDifference && !hasAreaDifference) return null;

    return (
        <>
            {hasPriceDifference && (
                <>
                    {priceDifference > 0 ? "Tańsze o " : "Droższe o "}
                    <strong>{priceValue}</strong>
                    {hasAreaDifference ? " " : ""}
                </>
            )}
            {hasAreaDifference && (
                <>
                    {areaDifference > 0 ? "mniejsze " : "większe "}
                    <strong>{areaValue}</strong>
                </>
            )}
        </>
    );
};
